import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBackground = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 88, viewBox: "0 0 22 88", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 4.00098L17 44.001L4 84.001", stroke: "#182231", strokeWidth: 8, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgArrowBackground);
export { ForwardRef as ReactComponent };
